import './App.css';
import Navbar from "./components/sharedComponents/navbar/navbar";
import Home from "./Pages/homePage/home";
import Menu from "./Pages/menu/menu";
import AboutUs from "./Pages/aboutUs/aboutUs";
import {Route, Routes} from "react-router-dom";
import Contact from "./Pages/contactUs/contact";
import SignUp from "./Pages/signUp/signUp";
import LogIn from "./Pages/logIn/logIn";
import {AuthContextProvider} from "./context/AuthContext";
import {TypeContextProvider} from "./context/type";
import {MenuItemsContextProvider} from "./context/menuItemsContext";
import Footer from "./components/sharedComponents/footer/footer";

function App()
{
	return (
		<div className="App">
			<AuthContextProvider>
				<MenuItemsContextProvider>
					<TypeContextProvider>
						<header className="App-header">
							<Navbar/>
						</header>
						<Routes>
							<Route path="/" element={<Home/>}/>
							<Route path="about" element={<AboutUs/>}/>
							<Route path="menu" element={<Menu/>}/>
							<Route path="contact" element={<Contact/>}/>
							<Route path="signUp" element={<SignUp/>}/>
							<Route path="logIn" element={<LogIn/>}/>
						</Routes>
						<footer>
							<Footer/>
						</footer>
					</TypeContextProvider>
				</MenuItemsContextProvider>
			</AuthContextProvider>

		</div>
	);
}

export default App;
